import { ref } from 'vue'
import { backButtonCallback } from '@/router'

const showLiveOpsChallengeModal = ref(false)
const selectedLeaderboardId = ref<string | null>(null)

export const useLiveOpsChallengeModal = () => {
  function openLiveOpsChallengeModal(leaderboardId?: string) {
    if (leaderboardId) {
      selectedLeaderboardId.value = leaderboardId
    }
    backButtonCallback.value = closeLiveOpsChallengeModal
    showLiveOpsChallengeModal.value = true
  }

  const closeLiveOpsChallengeModal = () => {
    backButtonCallback.value = null
    showLiveOpsChallengeModal.value = false
    selectedLeaderboardId.value = null
  }

  return {
    showLiveOpsChallengeModal,
    selectedLeaderboardId,
    openLiveOpsChallengeModal,
    closeLiveOpsChallengeModal,
  }
}
